// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    wm-related-pois-navigator {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      ion-button {
        height: 28px;
        width: 28px;
        --padding-start: 0;
        --padding-end: 0;
        --box-shadow: none;

        &.disabled {
          opacity: 0;
          pointer-events: none;
        }
      }

      span {
        font-size: var(--wm-font-sm);
        font-weight: 400;
      }
    }
  `, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/releted-pois-navigator/related-pois-navigator.component.ts"],"names":[],"mappings":";IACI;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;;MAET;QACE,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;;QAElB;UACE,UAAU;UACV,oBAAoB;QACtB;MACF;;MAEA;QACE,4BAA4B;QAC5B,gBAAgB;MAClB;IACF","sourcesContent":["\n    wm-related-pois-navigator {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n\n      ion-button {\n        height: 28px;\n        width: 28px;\n        --padding-start: 0;\n        --padding-end: 0;\n        --box-shadow: none;\n\n        &.disabled {\n          opacity: 0;\n          pointer-events: none;\n        }\n      }\n\n      span {\n        font-size: var(--wm-font-sm);\n        font-weight: 400;\n      }\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
